{
  "name": "chill.my-chill.onboarding.angular",
  "version": "3.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --output-hashing=all",
    "build:dev": "ng build --configuration=development --output-hashing=all",
    "build:uat": "ng build --configuration=staging --output-hashing=all",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:Chill.MyChill.Onboarding.Angular": "node dist/chill.my-chill.onboarding.angular/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.18",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.18",
    "@angular/compiler": "^21.2.18",
    "@angular/core": "^21.2.18",
    "@angular/forms": "^21.2.18",
    "@angular/material": "^21.2.14",
    "@angular/platform-browser": "^21.2.18",
    "@angular/platform-browser-dynamic": "^21.2.18",
    "@angular/platform-server": "^21.2.18",
    "@angular/router": "^21.2.18",
    "@angular/ssr": "^21.2.19",
    "@microsoft/applicationinsights-web": "^3.3.2",
    "express": "^4.18.2",
    "ngx-iban-validator": "^1.2.2",
    "ngx-mask": "^18.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.19",
    "@angular/cli": "^21.2.19",
    "@angular/compiler-cli": "^21.2.18",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.7",
    "@types/node": "^18.18.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}